// ════════════════════════════════════════════════════════════════
// 🔒 B317 (AI_143) — ESCAPE HTML: fonte única
// ════════════════════════════════════════════════════════════════
// Achado A1 da auditoria externa (Codex, AI_143): os geradores centrais de
// documentos (gerarPDF.ts, gerarPDFAgenda.ts) interpolavam dados do paciente
// e texto livre CRUS no HTML de impressão/assinatura — XSS armazenado se um
// campo carregasse HTML malicioso (ex.: texto vindo de PDF importado), pois
// o HTML é escrito em janela/iframe da MESMA ORIGEM (document.write) com
// sessão Firebase ativa e CSP que ainda permite script inline.
//
// Esta função é a PROMOÇÃO da escapeHtml que as fichas SUS já usavam
// (gerarFichaGAL.ts, B211) para util compartilhado — as fichas re-exportam
// daqui (import inalterado nos consumidores). Regra de uso nos geradores:
//   - escapar TODO valor de DADO interpolado (paciente.*, config do médico,
//     nome/posologia de medicamento, observações, títulos);
//   - NUNCA escapar fragmento HTML já montado (selo, QR, logo base64,
//     anexos {estilos, corpo}, saída de processarMarkdown);
//   - em texto com transformação (\n→<br>, mini-markdown), escapar ANTES.
export function escapeHtml(valor: string | undefined | null): string {
  if (!valor) return "";
  return String(valor)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
